import { jsx as K } from "react/jsx-runtime";
import { forwardRef as me, useRef as $, useMemo as W, useReducer as Ue, useLayoutEffect as Xe, useEffect as _, useImperativeHandle as Ve, memo as Be, useCallback as le, useState as ae, Fragment as qe } from "react";
import { flushSync as We } from "react-dom";
const F = -1, Ke = "chat-viewer-prefix-id", Ye = "chat-viewer-suffix-id", se = { align: "end" };
function Et(e = se) {
  return (t) => {
    if (t.atBottom)
      return requestAnimationFrame(() => t.scrollToBottom(e));
  };
}
function kt(e = se) {
  return (t) => requestAnimationFrame(() => t.scrollToBottom(e));
}
function Mt(e = se) {
  return (t) => requestAnimationFrame(() => t.scrollToBottom(e));
}
function Oe(e = se) {
  return (t) => {
    if (t.atBottom)
      return requestAnimationFrame(() => t.scrollToBottom(e));
  };
}
function Vt(e, t = se) {
  return (n, r) => r.some(e) ? requestAnimationFrame(() => n.scrollToBottom(t)) : Oe(t)(n, r);
}
function je(e = se) {
  return (t, n) => {
    if (n && t.atBottom)
      return requestAnimationFrame(() => t.scrollToBottom(e));
  };
}
const re = null, { min: G, max: H, abs: Ee, floor: Ze } = Math, Ce = (e, t, n) => G(n, H(t, e)), be = (e) => [...e].sort((t, n) => t - n), Ae = typeof queueMicrotask == "function" ? queueMicrotask : (e) => {
  Promise.resolve().then(e);
}, pe = (e) => {
  let t;
  return () => (e && (t = e(), e = void 0), t);
}, ne = -1, de = (e, t, n) => {
  const r = n ? "unshift" : "push";
  for (let l = 0; l < t; l++) e[r](ne);
  return e;
}, fe = (e, t) => {
  const n = e.t[t];
  return n === ne ? e.o : n;
}, Ge = (e, t, n) => {
  const r = e.t[t] === ne;
  return e.t[t] = n, e.i = G(t, e.i), r;
}, ce = (e, t) => {
  if (!e.l) return 0;
  if (e.i >= t) return e.u[t];
  e.i < 0 && (e.u[0] = 0, e.i = 0);
  let n = e.i, r = e.u[n];
  for (; n < t; ) r += fe(e, n), e.u[++n] = r;
  return e.i = t, r;
}, te = (e, t, n = 0, r = e.l - 1) => {
  for (; n <= r; ) {
    const l = Ze((n + r) / 2), d = ce(e, l);
    if (d <= t) {
      if (d + fe(e, l) > t) return l;
      n = l + 1;
    } else r = l - 1;
  }
  return Ce(n, 0, e.l - 1);
}, ke = (e, t, n) => {
  const r = t - e.l;
  return e.i = n ? -1 : G(t - 1, e.i), e.l = t, r > 0 ? (de(e.u, r), de(e.t, r, n), e.o * r) : (e.u.splice(r), (n ? e.t.splice(0, -r) : e.t.splice(r)).reduce((l, d) => l - (d === ne ? e.o : d), 0));
}, Ne = typeof window < "u", ze = () => document.documentElement, $e = (e) => e.ownerDocument, Qe = (e) => e.defaultView, Re = /* @__PURE__ */ pe(() => !!Ne && getComputedStyle(ze()).direction === "rtl"), De = /* @__PURE__ */ pe(() => /iP(hone|od|ad)/.test(navigator.userAgent)), et = /* @__PURE__ */ pe(() => "scrollBehavior" in ze().style), tt = (e) => H(e.h(), e.v()), nt = (e) => !!e.v(), ot = (e, t = 40, n = 4, r = 0, l, d = !1) => {
  let c = !!r, m = 1, o = 0, i = 0, S = 0, v = 0, h = 0, f = 0, x = 0, T = 0, E = c ? [0, H(r - 1, 0)] : re, g = [0, 0], V = 0;
  const k = ((s, w, B) => ({ o: B ? B[1] : w, t: B && B[0] ? de(B[0].slice(0, G(s, B[0].length)), H(0, s - B[0].length)) : de([], s), l: s, i: -1, u: de([], s) }))(e, t, l), Y = /* @__PURE__ */ new Set(), J = () => S - i, y = () => J() + h + v, U = (s) => ((w, B, b, M) => {
    if (M = G(M, w.l - 1), ce(w, M) <= B) {
      const O = te(w, B + b, M);
      return [te(w, B, M, O), O];
    }
    {
      const O = te(w, B, void 0, M);
      return [O, te(w, B + b, O)];
    }
  })(k, s, o, g[0]), N = () => ((s) => s.l ? ce(s, s.l - 1) + fe(s, s.l - 1) : 0)(k), X = (s) => ce(k, s) - h, q = (s) => fe(k, s), j = (s) => {
    s && (De() && x !== 0 ? h += s : v += s);
  };
  return { p: () => m, m: () => ((s) => [s.t.slice(), s.o])(k), _: () => {
    let s, w;
    return f ? [s, w] = g : ([s, w] = g = U(H(0, y())), E && (s = G(s, E[0]), w = H(w, E[1]))), x !== 1 && (s -= H(0, n)), x !== 2 && (w += H(0, n)), [H(s, 0), G(w, k.l - 1)];
  }, S: () => te(k, y()), $: () => te(k, y() + o), I: (s) => k.t[s] === ne, k: () => !!E && k.t.slice(H(0, E[0] - 1), G(k.l - 1, E[1] + 1) + 1).includes(ne), R: X, T: q, M: () => k.l, C: () => S, H: () => x !== 0, v: () => o, W: () => i, h: N, O: () => (f = v, v = 0, [f, T === 2 || J() + o >= N()]), B: (s, w) => {
    const B = [s, w];
    return Y.add(B), () => {
      Y.delete(B);
    };
  }, J: (s, w) => {
    let B, b, M = 0;
    switch (s) {
      case 1: {
        const O = f;
        f = 0;
        const a = w - S, p = Ee(a);
        O && p < Ee(O) + 1 || T !== 0 || (x = a < 0 ? 2 : 1), c && (E = re, c = !1), S = w, M = 4;
        const C = J();
        C >= -o && C <= N() && (M += 1, b = p > o);
        break;
      }
      case 2:
        M = 8, x !== 0 && (B = !0, M += 1), x = 0, T = 0, E = re;
        break;
      case 3: {
        const O = w.filter(([a, p]) => k.t[a] !== p);
        if (!O.length) break;
        j(O.reduce((a, [p, C]) => ((T === 2 || (E ? !c && p < E[0] : X(p) + (x === 0 && T === 0 ? q(p) : 0) < J())) && (a += C - q(p)), a), 0));
        for (const [a, p] of O) {
          const C = q(a), z = Ge(k, a, p);
          d && (V += z ? p : p - C);
        }
        d && o && V > o && (j(((a, p) => {
          let C = 0;
          const z = [];
          a.t.forEach((Z, Ie) => {
            Z !== ne && (z.push(Z), Ie < p && C++);
          }), a.i = -1;
          const R = be(z), Q = R.length, oe = Q / 2 | 0, D = Q % 2 == 0 ? (R[oe - 1] + R[oe]) / 2 : R[oe], L = a.o;
          return ((a.o = D) - L) * H(p - C, 0);
        })(k, te(k, y()))), d = !1), M = 3, b = !0;
        break;
      }
      case 4:
        o !== w && (o = w, M = 3);
        break;
      case 5:
        w[1] ? (j(ke(k, w[0], !0)), T = 2, M = 1) : (ke(k, w[0]), M = 1);
        break;
      case 6:
        i = w;
        break;
      case 7:
        T = 1;
        break;
      case 8:
        E = U(w), M = 1;
    }
    M && (m = 1 + (2147483647 & m), B && h && (v += h, h = 0), Y.forEach(([O, a]) => {
      M & O && a(b);
    }));
  } };
}, ve = setTimeout, ue = (e, t) => t && Re() ? -e : e, rt = (e, t, n, r, l, d) => {
  const c = Date.now;
  let m = 0, o = !1, i = !1, S = !1, v = !1;
  const h = (() => {
    let g;
    const V = () => {
      g != re && clearTimeout(g);
    }, k = () => {
      V(), g = ve(() => {
        g = re, (() => {
          if (o || i) return o = !1, void h();
          S = !1, e.J(2);
        })();
      }, 150);
    };
    return k.L = V, k;
  })(), f = () => {
    m = c(), S && (v = !0), e.J(1, r()), h();
  }, x = (g) => {
    if (o || !e.H() || g.ctrlKey) return;
    const V = c() - m;
    150 > V && 50 < V && (n ? g.deltaX : g.deltaY) && (o = !0);
  }, T = () => {
    i = !0, S = v = !1;
  }, E = () => {
    i = !1, De() && (S = !0);
  };
  return t.addEventListener("scroll", f), t.addEventListener("wheel", x, { passive: !0 }), t.addEventListener("touchstart", T, { passive: !0 }), t.addEventListener("touchend", E, { passive: !0 }), { P: () => {
    t.removeEventListener("scroll", f), t.removeEventListener("wheel", x), t.removeEventListener("touchstart", T), t.removeEventListener("touchend", E), h.L();
  }, A: () => {
    const [g, V] = e.O();
    g && (l(ue(g, n), V, v), v = !1, V && e.v() > e.h() && e.J(1, r()));
  } };
}, st = (e, t) => {
  let n, r, l;
  const d = t ? "scrollLeft" : "scrollTop", c = t ? "overflowX" : "overflowY", m = async (o, i) => {
    if (!n) return void Ae(() => m(o, i));
    l && l();
    const S = () => {
      let v;
      return [new Promise((h, f) => {
        v = h, l = f, nt(e) && ve(f, 150);
      }), e.B(2, () => {
        v && v();
      })];
    };
    if (i && et()) {
      for (; e.J(8, o()), e.k(); ) {
        const [v, h] = S();
        try {
          await v;
        } catch {
          return;
        } finally {
          h();
        }
      }
      n.scrollTo({ [t ? "left" : "top"]: ue(o(), t), behavior: "smooth" });
    } else for (; ; ) {
      const [v, h] = S();
      try {
        n[d] = ue(o(), t), e.J(7), await v;
      } catch {
        return;
      } finally {
        h();
      }
    }
  };
  return { D(o) {
    n = o, r = rt(e, o, t, () => ue(o[d], t), (i, S, v) => {
      if (v) {
        const h = o.style, f = h[c];
        h[c] = "hidden", ve(() => {
          h[c] = f;
        });
      }
      S ? (o[d] = e.C() + i, l && l()) : o[d] += i;
    });
  }, V() {
    r && r.P();
  }, X(o) {
    m(() => o);
  }, Y(o) {
    o += e.C(), m(() => o);
  }, j(o, { align: i, smooth: S, offset: v = 0 } = {}) {
    if (o = Ce(o, 0, e.M() - 1), i === "nearest") {
      const h = e.R(o), f = e.C();
      if (h < f) i = "start";
      else {
        if (!(h + e.T(o) > f + e.v())) return;
        i = "end";
      }
    }
    m(() => v + e.W() + e.R(o) + (i === "end" ? e.T(o) - e.v() : i === "center" ? (e.T(o) - e.v()) / 2 : 0), S);
  }, q: () => {
    r && r.A();
  } };
}, it = (e) => {
  let t;
  return { U(n) {
    (t || (t = new (Qe($e(n))).ResizeObserver(e))).observe(n);
  }, F(n) {
    t.unobserve(n);
  }, P() {
    t && t.disconnect();
  } };
}, lt = (e, t) => {
  let n;
  const r = t ? "width" : "height", l = /* @__PURE__ */ new WeakMap(), d = it((c) => {
    const m = [];
    for (const { target: o, contentRect: i } of c) if (o.offsetParent) if (o === n) e.J(4, i[r]);
    else {
      const S = l.get(o);
      S != re && m.push([S, i[r]]);
    }
    m.length && e.J(3, m);
  });
  return { G(c) {
    d.U(n = c);
  }, K: (c, m) => (l.set(c, m), d.U(c), () => {
    l.delete(c), d.F(c);
  }), V: d.P };
}, he = Ne ? Xe : _, P = "current", Le = (e, t) => {
  if (Array.isArray(e)) for (const n of e) Le(n, t);
  else e == null || typeof e == "boolean" || t.push(e);
}, dt = (e, t) => {
  const n = e.key;
  return n ?? "_" + t;
}, ct = (e) => {
  const t = $();
  return t[P] || (t[P] = e());
}, Me = (e) => {
  const t = $(e);
  return he(() => {
    t[P] = e;
  }, [e]), t;
}, ut = /* @__PURE__ */ Be(({ N: e, Z: t, ee: n, te: r, ne: l, oe: d, re: c, ie: m }) => {
  const o = $(null);
  he(() => t(o[P], n), [n]);
  const i = W(() => {
    const S = { position: l && m ? void 0 : "absolute", [c ? "height" : "width"]: "100%", [c ? "top" : "left"]: 0, [c ? Re() ? "right" : "left" : "top"]: r, visibility: !l || m ? "visible" : "hidden" };
    return c && (S.display = "flex"), S;
  }, [r, l, m, c]);
  return K(d, typeof d == "string" ? { ref: o, style: i, children: e } : { ref: o, style: i, index: n, children: e });
}), at = (e, t) => W(() => {
  if (typeof e == "function") return [e, t || 0];
  const n = ((r) => {
    const l = [];
    return Le(r, l), l;
  })(e);
  return [(r) => n[r], n.length];
}, [e, t]), ft = /* @__PURE__ */ me(({ children: e, count: t, overscan: n, itemSize: r, shift: l, horizontal: d, keepMounted: c, cache: m, startMargin: o = 0, ssrCount: i, as: S = "div", item: v = "div", scrollRef: h, onScroll: f, onScrollEnd: x }, T) => {
  const [E, g] = at(e, t), V = $(null), k = $(!!i), Y = Me(f), J = Me(x), [y, U, N, X] = ct(() => {
    const a = !!d, p = ot(g, r, n, i, m, !r);
    return [p, lt(p, a), st(p, a), a];
  });
  g !== y.M() && y.J(5, [g, l]), o !== y.W() && y.J(6, o);
  const [q, j] = Ue(y.p, void 0, y.p), [s, w] = y._(), B = y.H(), b = y.h(), M = [], O = (a) => {
    const p = E(a);
    return K(ut, { Z: U.K, ee: a, te: y.R(a), ne: y.I(a), oe: v, N: p, re: X, ie: k[P] }, dt(p, a));
  };
  he(() => {
    k[P] = !1;
    const a = y.B(1, (R) => {
      R ? We(j) : j();
    }), p = y.B(4, () => {
      Y[P] && Y[P](y.C());
    }), C = y.B(8, () => {
      J[P] && J[P]();
    }), z = (R) => {
      U.G(R), N.D(R);
    };
    return h ? Ae(() => z(h[P])) : z(V[P].parentElement), () => {
      a(), p(), C(), U.V(), N.V();
    };
  }, []), he(() => {
    N.q();
  }, [q]), Ve(T, () => ({ get cache() {
    return y.m();
  }, get scrollOffset() {
    return y.C();
  }, get scrollSize() {
    return tt(y);
  }, get viewportSize() {
    return y.v();
  }, findStartIndex: y.S, findEndIndex: y.$, getItemOffset: y.R, getItemSize: y.T, scrollToIndex: N.j, scrollTo: N.X, scrollBy: N.Y }), []);
  for (let a = s, p = w; a <= p; a++) M.push(O(a));
  if (c) {
    const a = [], p = [];
    be(c).forEach((C) => {
      C < s && a.push(O(C)), C > w && p.push(O(C));
    }), M.unshift(...a), M.push(...p);
  }
  return K(S, { ref: V, style: { overflowAnchor: "none", flex: "none", position: "relative", visibility: "hidden", width: X ? b : "100%", height: X ? "100%" : b, pointerEvents: B ? "none" : void 0 }, children: M });
}), ht = /* @__PURE__ */ me(({ children: e, count: t, overscan: n, itemSize: r, shift: l, horizontal: d, keepMounted: c, reverse: m, cache: o, ssrCount: i, item: S, onScroll: v, onScrollEnd: h, style: f, ...x }, T) => {
  const E = $(null), g = m && !d;
  let V = K(ft, { ref: T, scrollRef: g ? E : void 0, count: t, overscan: n, itemSize: r, shift: l, horizontal: d, keepMounted: c, cache: o, ssrCount: i, item: S, onScroll: v, onScrollEnd: h, children: e });
  return g && (V = K("div", { style: { visibility: "hidden", display: "flex", flexDirection: "column", justifyContent: "flex-end", minHeight: "100%" }, children: V })), K("div", { ref: E, ...x, style: { display: d ? "inline-block" : "block", [d ? "overflowX" : "overflowY"]: "auto", contain: "strict", width: "100%", height: "100%", ...f }, children: V });
});
function It(e) {
  return {
    messages: e.messages,
    renderMessage: e.renderMessage,
    prefix: e.prefix ?? null,
    suffix: e.suffix ?? null,
    alignment: e.alignment ?? "bottom",
    style: e.style,
    className: e.className,
    scrollerStyle: e.scrollerStyle,
    scrollerClassName: e.scrollerClassName,
    overscan: e.overscan,
    ssrCount: e.ssrCount,
    keepMountedIndexes: e.keepMountedIndexes,
    keepMountedIds: e.keepMountedIds,
    historyEndOffset: e.historyEndOffset ?? 10,
    onHistoryEndReached: e.onHistoryEndReached ?? (() => {
    }),
    onScroll: e.onScroll ?? (() => {
    }),
    onScrollEnd: e.onScrollEnd ?? (() => {
    }),
    onWheel: e.onWheel ?? (() => {
    }),
    onKeyDown: e.onKeyDown ?? (() => {
    }),
    onOlderMessages: e.onOlderMessages ?? (() => {
    }),
    onNewerMessages: e.onNewerMessages ?? Oe(),
    onAtTop: e.onAtTop ?? (() => {
    }),
    onAtBottom: e.onAtBottom ?? (() => {
    }),
    onPrefixDisplay: e.onPrefixDisplay ?? (() => {
    }),
    onSuffixDisplay: e.onSuffixDisplay ?? je()
  };
}
function wt(e) {
  const t = $([]), n = t.current.map((i) => i.id), r = e.map((i) => i.id);
  if (_(() => {
    t.current = e;
  }, [e]), n.length === 0)
    return { prepended: [], appended: e };
  if (r.length === 0)
    return { prepended: [], appended: [] };
  const l = new Set(n);
  let d = -1;
  for (let i = 0; i < r.length; i++)
    if (l.has(r[i])) {
      d = i;
      break;
    }
  if (d === -1)
    return { prepended: [], appended: e };
  let c = -1;
  for (let i = r.length - 1; i >= 0; i--)
    if (l.has(r[i])) {
      c = i;
      break;
    }
  if (c === -1)
    return { prepended: e, appended: [] };
  const m = e.slice(0, d), o = e.slice(c + 1);
  return { prepended: m, appended: o };
}
function vt(e, t) {
  const { vListHandle: n, idsToIndexes: r, indexesToIds: l } = e, d = le(() => {
    const f = n.current, x = f?.findStartIndex() ?? F, T = f?.findEndIndex() ?? F, E = l.get(x), g = l.get(T);
    return {
      oldestIndexInViewport: x,
      newestIndexInViewport: T,
      oldestIdInViewport: E,
      newestIdInViewport: g
    };
  }, [n, l]), [c, m] = ae(
    () => d().newestIdInViewport
  ), [o, i] = ae(
    () => d().oldestIdInViewport
  ), S = le(() => {
    const { newestIdInViewport: f, newestIndexInViewport: x } = d(), T = r.get(c ?? -1) ?? F, E = f !== void 0 && x !== F, g = T === F, V = T !== F && x > T;
    E && (g || V) && m(f);
  }, [d, r, c]), v = le(() => {
    const { oldestIdInViewport: f, oldestIndexInViewport: x } = d(), T = r.get(o ?? -1) ?? F, E = f !== void 0 && x !== F, g = T === F, V = T !== F && x < T;
    E && (g || V) && i(f);
  }, [d, r, o]), h = le(() => {
    S(), v();
  }, [S, v]);
  return _(() => {
    const { newestIdInViewport: f, oldestIdInViewport: x } = d();
    c === void 0 && f !== void 0 && m(f), o === void 0 && x !== void 0 && i(x), h();
  }, [d, c, o, h]), _(() => h(), [t, h]), {
    newestSeenId: c,
    oldestSeenId: o,
    newestSeenIndex: c ? r.get(c) : void 0,
    oldestSeenIndex: o ? r.get(o) : void 0,
    trackSeen: h
  };
}
const ie = (e, t) => e < 0 ? t + e : e, we = (e, t) => ({
  id: e,
  element: t
}), Fe = 1.5, mt = (e, t, n) => t - (e + n) < Fe, pt = (e) => e < Fe;
function St(e, t) {
  const {
    style: n,
    className: r,
    scrollerStyle: l,
    scrollerClassName: d,
    alignment: c,
    overscan: m,
    keepMountedIndexes: o,
    keepMountedIds: i,
    ssrCount: S,
    messages: v,
    renderMessage: h,
    prefix: f,
    suffix: x,
    historyEndOffset: T,
    onHistoryEndReached: E,
    onScroll: g,
    onScrollEnd: V,
    onWheel: k,
    onKeyDown: Y,
    onOlderMessages: J,
    onNewerMessages: y,
    onAtTop: U,
    onAtBottom: N,
    onPrefixDisplay: X,
    onSuffixDisplay: q
  } = It(e), j = t, s = $(null), [w, B] = ae(!1), [b, M] = ae(!0), { prepended: O, appended: a } = wt(v), p = c === "bottom", C = !!O.length, z = W(
    () => f ? we(Ke, f) : null,
    [f]
  ), R = !!z, Q = W(
    () => x ? we(Ye, x) : null,
    [x]
  ), oe = !!Q, D = W(
    () => [
      ...z ? [z] : [],
      ...v.map(
        (u, I, ee) => we(u.id, h(u, I, ee))
      ),
      ...Q ? [Q] : []
    ],
    [v, z, h, Q]
  ), [L, Z] = W(
    () => [
      new Map(D.map((u, I) => [u.id, I])),
      new Map(D.map((u, I) => [I, u.id]))
    ],
    [D]
  ), Ie = W(() => o || (i ? i.map((u) => L.get(u)).filter((u) => u !== void 0) : []), [o, i, L]), {
    newestSeenId: Se,
    newestSeenIndex: xe,
    oldestSeenId: ge,
    oldestSeenIndex: ye,
    trackSeen: Te
  } = vt(
    {
      vListHandle: s,
      idsToIndexes: L,
      indexesToIds: Z
    },
    v
  ), A = W(
    () => ({
      vListHandle: s.current,
      scrollOffset: s.current?.scrollOffset,
      scrollSize: s.current?.scrollSize,
      viewportSize: s.current?.viewportSize,
      atTop: w,
      atBottom: b,
      idsToIndexes: L,
      indexesToIds: Z,
      newestSeenId: Se,
      newestSeenIndex: xe,
      oldestSeenId: ge,
      oldestSeenIndex: ye,
      get oldestIndexInViewport() {
        return s.current?.findStartIndex() ?? F;
      },
      get oldestIdInViewport() {
        return Z.get(this.oldestIndexInViewport);
      },
      get newestIndexInViewport() {
        return s.current?.findEndIndex() ?? F;
      },
      get newestIdInViewport() {
        return Z.get(this.newestIndexInViewport);
      },
      isIndexInViewport(u) {
        const I = ie(u, D.length);
        return I >= this.oldestIndexInViewport && I <= this.newestIndexInViewport;
      },
      isIdInViewport(u) {
        const I = L.get(u);
        return I !== void 0 ? this.isIndexInViewport(I) : !1;
      },
      wasIndexSeen(u) {
        const I = ie(u, D.length);
        return this.oldestSeenIndex !== void 0 && this.newestSeenIndex !== void 0 ? I >= this.oldestSeenIndex && I <= this.newestSeenIndex : !1;
      },
      wasIdSeen(u) {
        const I = L.get(u);
        return I !== void 0 ? this.wasIndexSeen(I) : !1;
      },
      getIndexOffset(u) {
        const I = ie(u, D.length);
        return s.current?.getItemOffset(I);
      },
      getIdOffset(u) {
        const I = L.get(u);
        if (I !== void 0)
          return this.getIndexOffset(I);
      },
      getIndexSize(u) {
        const I = ie(u, D.length);
        return s.current?.getItemSize(I);
      },
      getIdSize(u) {
        const I = L.get(u);
        if (I !== void 0)
          return this.getIndexSize(I);
      },
      scrollToOffset(u) {
        s.current?.scrollTo(u);
      },
      scrollToIndex(u, I) {
        s.current?.scrollToIndex(
          ie(u, D.length),
          I
        );
      },
      scrollToId(u, I) {
        const ee = L.get(u);
        ee !== void 0 && this.scrollToIndex(ee, I);
      },
      scrollBy(u) {
        s.current?.scrollBy(u);
      },
      scrollToTop(u) {
        this.scrollToIndex(0, u);
      },
      scrollToBottom(u) {
        this.scrollToIndex(-1, u);
      }
    }),
    [
      w,
      b,
      L,
      Z,
      D.length,
      Se,
      xe,
      ge,
      ye
    ]
  );
  Ve(
    j,
    () => A,
    [A]
  );
  const Pe = W(
    () => ({
      /*
       overscroll-behavior: contain is needed here to prevent scrolling
       the whole page when the user scrolls to the top or bottom of the chat.
       MDN: https://developer.mozilla.org/en-US/docs/Web/CSS/overscroll-behavior
      */
      overscrollBehavior: "contain",
      /*
       overflow-x: hidden is required here, to prevent scroll wobbling with animated messages.
       Issue: https://github.com/inokawa/virtua/pull/485
      */
      overflowX: "hidden",
      ...l
    }),
    [l]
  );
  _(() => {
    w && U?.(A);
  }, [A, w, U]), _(() => {
    b && N?.(A);
  }, [A, b, N]), _(
    () => void X?.(A, R),
    [A, X, R]
  ), _(
    () => void q(A, oe),
    [A, q, oe]
  ), _(() => {
    O.length && J?.(A, O);
  }, [A, O, J]), _(() => {
    a.length && y?.(A, a);
  }, [A, a, y]);
  const He = le(
    (u) => {
      if (g?.(u), s.current) {
        const { viewportSize: I, scrollSize: ee } = s.current;
        B(pt(u)), M(mt(u, ee, I));
        const Je = u < T, _e = I > 0 && I < ee;
        !b && _e && Je && E?.(A);
      }
      Te();
    },
    [
      g,
      Te,
      b,
      T,
      E,
      A
    ]
  );
  return /* @__PURE__ */ K("div", { style: n, className: r, children: /* @__PURE__ */ K(
    ht,
    {
      reverse: p,
      ref: s,
      style: Pe,
      shift: C,
      className: d,
      overscan: m,
      keepMounted: Ie,
      ssrCount: S,
      onScroll: He,
      onScrollEnd: V,
      onWheel: k,
      onKeyDown: Y,
      children: D.map(({ id: u, element: I }) => /* @__PURE__ */ K(qe, { children: I }, u))
    }
  ) });
}
const Bt = Be(me(St));
export {
  Bt as ChatViewer,
  F as IDX_NOT_FOUND,
  Ke as PREFIX_ID,
  Ye as SUFFIX_ID,
  kt as followAlways,
  Et as followAtBottom,
  Mt as followEveryMessage,
  Oe as followMessagesAtBottom,
  Vt as followMessagesBy,
  je as followSuffixAtBottom
};
